import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onRefreshAdminMonitoring: () => void;
}

export const AdminMonitoringHeader: React.FC<Props> = ({
  onRefreshAdminMonitoring,
}) => {
  const { t } = useTranslation('monitoring');
  useEffect(() => {
    onRefreshAdminMonitoring();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="h4" component="h4">
        {t('title')}
      </Typography>

      <Box sx={{ display: 'flex' }}>
        <Tooltip title={t('refreshTooltip')}>
          <IconButton
            aria-label="refresh"
            size="large"
            onClick={onRefreshAdminMonitoring}
          >
            <RefreshIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default AdminMonitoringHeader;
